import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import BackBtn from "../../components/Template/Btns/BackBtn";
import { FontIcon } from "@fluentui/react";
import { Popover } from "antd";
import { useAppDispatch } from "../../redux/useAppDispatch";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import PdfViewerComponent from "../../components/EngageTranslationComponent/PdfViewerComponent/PdfViewerComponent";
import LoadingPage from "../template/LoadingPage/LoadingPage";
import DocumentEditorViewer from "../../components/EngageTranslationComponent/DocumentEditorViewer/DocumentEditorViewer";
import { fetchViewDocumentDetailsPresigned, getDocumentPresigned, setCustomFont } from "../../redux/EngageTranslation/EngageTranslationAction";
import PSPDFKit from "pspdfkit";
import TransferToQCModal from "../../components/EngageTranslationComponent/Modal/TransferToQCModal/TransferToQCModal";
import TransferToQCStatusModal from "../../components/EngageTranslationComponent/Modal/TransferToQCModal/TransferToQCStatusModal";
import "./ViewQuickUploadDocumentPage.css";

function ViewQuickUploadDocumentPage(props: any) {
  const wordDocumentViewerRef = useRef(null) as any;
  const wordDocumentViewerRef2 = useRef(null) as any;
  const pdfViewerDual1 = useRef<HTMLDivElement>(null);
  const pdfViewerDual2 = useRef<HTMLDivElement>(null);
  const customFontState = useSelector((state: RootState) => state.engageTranslationState.customFonts);
  const dispatch = useAppDispatch();
  const engageTranslationViewDocumentPageState = useSelector((state: RootState) => state.engageTranslationState.engageTranslationViewDocumentPageState);
  const [transferToQcModalOpenState, setTransferToQcModalOpenState] = useState(false);
  const [transferToQcConfirmationOpenState, setTransferToQcConfirmationOpenState] = useState(false);

  const location = useLocation();
  const urlDivided = location.pathname.split("/");
  const documentId = Number(urlDivided[2]);

  useEffect(() => {
    dispatch(fetchViewDocumentDetailsPresigned({ selectedRecordID: Number(documentId) }));
  }, []);

  const fetcher = (fontFileName: string) =>
    fetch(`/dynamicFonts/${fontFileName}`, {
      // Adding Get request
      // Setting response type to arraybuffer
      // Setting response type to arraybuffer
    }).then(async (r) => {
      if (r.ok) {
        return r.blob();
      } else {
        throw new Error();
      }
    });

  useEffect(() => {
    if (customFontState === null) {
      const customFonts = ["NotoSansSC-Regular.otf", "NotoSansSC-Bold.otf", "NotoSansJP-Bold.otf", "NotoSansJP-Regular.otf", "NotoSansKR-Regular.otf", "NotoSansKR-Bold.otf", "NotoSansTC-Bold.otf", "NotoSansTC-Regular.otf"].map((font) => {
        const pspdfFont = new PSPDFKit.Font({
          name: font,
          callback: fetcher,
        });
        return pspdfFont;
      });
      dispatch(setCustomFont(customFonts));
    }
  }, []);

  if (engageTranslationViewDocumentPageState.loading) {
    return <LoadingPage />;
  }

  const PopOverContent = () => {
    return (
      <div>
        <div>
          <b>Name: </b>
          <span>{engageTranslationViewDocumentPageState.documentDetail.name}</span>
        </div>
        <div>
          <b>Input Language: </b>
          <span>{engageTranslationViewDocumentPageState.documentDetail.sourceLanguageName}</span>
        </div>
        <div>
          <b>Output Language: </b>
          <span>{engageTranslationViewDocumentPageState.documentDetail.targetLanguageName}</span>
        </div>
        <div>
          <b>Client Name: </b>
          <span>{engageTranslationViewDocumentPageState.documentDetail.clientName}</span>
        </div>

        <div>
          <b>Uploaded by: </b>
          <span>{engageTranslationViewDocumentPageState.documentDetail.uploadedBy}</span>
        </div>
        <div>
          <b>QC assigned to: </b>
          <span>{engageTranslationViewDocumentPageState.documentDetail.qcAssignedTo}</span>
        </div>
      </div>
    );
  };

  function openTransferToQCModal() {
    setTransferToQcModalOpenState(true);
  }
  function closeTransferToQCModal() {
    setTransferToQcModalOpenState(false);
  }

  function openTransferToQCConfirmation() {
    setTransferToQcConfirmationOpenState(true);
  }
  function closeTransferToQCConfirmation() {
    setTransferToQcConfirmationOpenState(false);
  }

  return (
    <div className="body-container d-flex flex-column px-3">
      <TransferToQCModal
        open={openTransferToQCModal}
        close={closeTransferToQCModal}
        openState={transferToQcModalOpenState}
        openTransferToQCConfirmation={openTransferToQCConfirmation}
        documentId={documentId}
      />

      <TransferToQCStatusModal
        open={openTransferToQCConfirmation}
        close={closeTransferToQCConfirmation}
        openState={transferToQcConfirmationOpenState}
      />

      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-center gap-2">
          <BackBtn backTo="client-ready" />
          <h5 className="document-view-title">{engageTranslationViewDocumentPageState.documentDetail.name}</h5>

          <Popover
            content={<PopOverContent />}
            title="Document Information">
            <FontIcon
              iconName="Info"
              className="document-view-info-icon"
            />
          </Popover>
        </div>

        <div className="d-flex gap-3 align-items-center">
          <button
            onClick={openTransferToQCModal}
            className="button action transfer-qc-btn">
            Transfer to QC
          </button>
          <button
            className="button action gap-1 view-download-btn"
            onClick={() => {
              dispatch(
                getDocumentPresigned({
                  selectedRecordID: documentId,
                  action: "download",
                })
              );
            }}>
            <FontIcon
              style={{ fontSize: "12px", marginTop: "1px" }}
              iconName="Download"
            />
            Download
          </button>
        </div>
      </div>

      {engageTranslationViewDocumentPageState.documentDetail.fileFormat === "pdf" ? (
        <div className="container-wrapper">
          <PdfViewerComponent
            document={engageTranslationViewDocumentPageState.documentDetail.inputPathPresignedUrl}
            refContainer={pdfViewerDual1}
            customFonts={customFontState}
          />

          <PdfViewerComponent
            document={engageTranslationViewDocumentPageState.documentDetail.outputPathPresignedUrl}
            refContainer={pdfViewerDual2}
            customFonts={customFontState}
          />
        </div>
      ) : (
        <div className="container-wrapper">
          <DocumentEditorViewer
            editable={false}
            document={engageTranslationViewDocumentPageState.documentDetail.sfdtInput}
            refContainer={wordDocumentViewerRef}
          />
          <DocumentEditorViewer
            editable={false}
            document={engageTranslationViewDocumentPageState.documentDetail.sfdtOutput}
            refContainer={wordDocumentViewerRef2}
          />
        </div>
      )}
    </div>
  );
}

export default ViewQuickUploadDocumentPage;
